import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromInvitesStore from '../reducers/invite.reducer';
import * as fromInvites from '@fc-store/reducers/invite.reducer';
export const getInvitesState = createFeatureSelector<fromInvites.State>(
  fromInvites.invitesFeatureKey,
);
export const getAllInvites = createSelector(
  getInvitesState,
  fromInvitesStore.selectAll,
);

export const getInvitesLoading = createSelector(
  getInvitesState,
  fromInvitesStore.getInvitesLoading,
);
